
define('ldsh!modules/start/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isGroupCPSAgreementsAccepted) { ;
__p += '\n    <div class="row">\n        <div id="products-welcome" class="col-md-6 col-lg-7 hidden-xs hidden-sm">\n            <div class="products-welcome">\n                <span class="i18n" data-i18n="PUBLIC.PRODUCTS.LBL_HELLO"></span>\n                ' +
((__t = (userName)) == null ? '' : __t) +
',<br/>\n                <span class="i18n welcome-subtext" data-i18n="PUBLIC.PRODUCTS.LBL_HELLO_MESSAGE"></span>\n            </div>\n        </div>\n        <div id="products-company-selector" class="col-xs-12 col-sm-12 col-md-6 col-lg-5 text-right"></div>\n    </div>\n';
 } ;
__p += '\n\n<div id="products-dashboard"></div>\n<div id="auto-message" class="alert alert-success alert-dismissable col-md-12" style="margin-top: 20px;display:none;">\n    <button type="button" class="close" data-dismiss="alert" aria-label="close" style="font-size:40px;top:-16px;">&times;</button>\n    <i id="alert-icon" class="fa fa-check-circle-o" style="font-size: 40px; float: left;margin-left: 15px;"></i>\n    <div style="margin-left:85px;">\n        <p class="i18n" data-i18n="[html]PUBLIC.PRODUCTS.AUTOMATION.SUCCESS_AUTO_MESSAGE" style="margin-bottom:0px;"></p>\n        <span class="i18n" data-i18n="[html]PUBLIC.PRODUCTS.AUTOMATION.SUCCESS_AUTO_MESSAGE_2"></span>\n    </div>\n</div>\n';
 if (!products.isRequest && !productsReport.isRequest) {;
__p += '\n    <div id="products-list"></div>\n';
 } ;
__p += '\n\n<div id=\'renderModalInvoice\'></div>\n';

}
return __p
};});

